import { Box } from "@mui/material";
import { useTheme } from "contexts";
import { EnumTheme } from "utils/enums";

export type MetricItemProps = {
  label: string;
  value: string;
  description: string;
};

export const Metric = ({ label, value, description }: MetricItemProps) => {
  const { theme } = useTheme();
  const isDark = theme.id === EnumTheme.Dark;

  return (
    <Box
      sx={{
        p: theme.spacing.sm,
        backgroundColor: theme.color.background.accent,
        border: `1px solid ${theme.color.border.color}`,
        borderRadius: theme.border.square,
        boxShadow: `2px 2px 0px 0px ${theme.color.border.color}`,
        transition: "transform 0.15s ease, box-shadow 0.15s ease",
        height: "100%",
        "&:hover": {
          transform: "translate(-2px, -2px)",
          boxShadow: `4px 4px 0px 0px ${isDark ? "#000000" : "#191b22"}`,
        },
      }}
    >
      <Box
        sx={{
          fontFamily: '"Space Mono", monospace',
          fontSize: theme.font.xxxs,
          fontWeight: theme.font.bold,
          color: theme.color.primary.color,
          letterSpacing: "0.08em",
        }}
      >
        {label}
      </Box>
      <Box
        sx={{
          fontSize: theme.font.md,
          fontWeight: theme.font.bold,
          mt: 0.5,
          color: theme.color.font.color,
        }}
      >
        {value}
      </Box>
      <Box
        sx={{
          fontSize: theme.font.xs,
          color: theme.color.font.accent,
          mt: 0.25,
        }}
      >
        {description}
      </Box>
    </Box>
  );
};
